import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { ArrowBack } from '@bibliocommons/base-icons';
import Heading from '@bibliocommons/heading';

import { ROUTE } from 'app/constants/AdminBrowseConstants';

const AdminBrowseHomeEditPage = ({ browseHomePage, hasSuccessNotice, onSave }) => {
  const [browseHomePageCopy, setBrowseHomePageCopy] = useState({ ...browseHomePage });

  const handleSubmit = event => {
    event.preventDefault();

    onSave(browseHomePageCopy);
  };

  const handleTitleChange = event => {
    const title = event.target.value;

    setBrowseHomePageCopy(prevBrowseHomePageCopy => {
      return {
        ...prevBrowseHomePageCopy,
        title
      };
    });
  };

  const { browseHomePageId, title } = browseHomePageCopy;
  return (
    <div className="cp-admin-browse-home-edit-page container">
      <Link
        dataKey="back-to-browse-home"
        to={ROUTE.ADMIN_BROWSE_HOME}
        style={{ color: 'var(--generic-darkgrey)', fontWeight: 600, textDecoration: 'none' }}
      >
        <span style={{ marginRight: '6px' }}>
          <ArrowBack />
        </span>
        <span>Back to Browse Home</span>
      </Link>

      {hasSuccessNotice && <p style={{ background: 'green', color: 'white', padding: '10px' }}>Saved!</p>}

      <Heading size="large" tagName="h1" variant>
        Browse Home Edit
      </Heading>

      <p>Browse Home Page ID: {browseHomePageId}</p>

      <form onSubmit={handleSubmit}>
        <label htmlFor="BrowsePageTitle">Title</label>
        <br />
        <input
          id="BrowsePageTitle"
          name="BrowsePageTitle"
          onChange={handleTitleChange}
          placeholder="Title"
          required
          type="text"
          value={title}
        />
        <br />
        <br />
        <button type="submit">Save</button>
      </form>
    </div>
  );
};

AdminBrowseHomeEditPage.propTypes = {
  browseHomePage: PropTypes.shape({
    browseHomePageId: PropTypes.string.isRequired
  }).isRequired,
  hasSuccessNotice: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired
};

export default AdminBrowseHomeEditPage;
